var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:{'clickable': _vm.clickable},on:{"click":_vm.handleClick}},[_c('span',[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }